import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { firestore } from "../../utils/firebase-config";
import { COLLECTIONS } from "../../assets/enums/firebase-colections";
import { VehiclesInfoDTO, VehiclesDTO, ObservationsDTO } from "./vehicles-DTO";
import {
  saveFiles,
  saveNewAsync,
  removeItemFromArrayField,
  saveNewWithId,
  update,
} from "../../services/persistence";
import { FOLDERS } from "../../assets/enums/storage-folders";

// add new
export async function addNewVehicle(
  data: VehiclesDTO,
  id: string,
  files: File[],
  removedFiles: string[]
) {
  if (
    data.vehiclesInfoDTO &&
    Array.isArray(data.vehiclesInfoDTO.files)
  ) {
    data.vehiclesInfoDTO.files =
      data.vehiclesInfoDTO.files.filter(
        (image) => !removedFiles.includes(image)
      );
  }
  if (data.id == undefined) {
    data.vehiclesInfoDTO.originId = id;
    saveNewAsync(COLLECTIONS.VEHICLES, data.vehiclesInfoDTO).then((docRef) => {
      saveNewWithId(COLLECTIONS.OBSERVATIONS, data.observations, docRef.id);
      if (files.length > 0) {
        saveFiles(
          COLLECTIONS.VEHICLES,
          docRef.id,
          FOLDERS.VEHICLES,
          files,
          "files"
        );
      }
    });
  } else {
    update(COLLECTIONS.VEHICLES, data.vehiclesInfoDTO, data.id);
    update(COLLECTIONS.OBSERVATIONS, data.observations, data.id);
    if (files != null && files.length > 0) {
      saveFiles(
        COLLECTIONS.VEHICLES,
        data.id,
        FOLDERS.VEHICLES,
        files,
        "files"
      );
    }
    if (removedFiles != null && removedFiles.length > 0) {
      removedFiles.forEach((fileUrl) => {
        removeItemFromArrayField(
          COLLECTIONS.VEHICLES,
          data.vehiclesInfoDTO.id,
          "files",
          fileUrl
        );
      });
    }
  }
}

export async function getVehiclesById(id: string): Promise<VehiclesInfoDTO[]> {
  const vehiclesCollectionRef = collection(firestore, COLLECTIONS.VEHICLES);

  const q = query(vehiclesCollectionRef, where("originId", "==", id));

  const querySnapshot = await getDocs(q);

  const items = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
    searchData: doc.data()["licensePlate"].concat(" ", doc.data()["type"]),
  })) as unknown as VehiclesInfoDTO[];
  return items;
}

export const getVehicleById = async (
  id: string
): Promise<VehiclesDTO | null> => {
  const vehiclesInfoDTO = await getVehicle(id);
  const observations = await getVehicleObservation(id);

  return {
    id,
    vehiclesInfoDTO,
    observations,
  };
};

export async function getVehiclesByGeneratorAndDealer(
  dealerId: string,
): Promise<VehiclesInfoDTO[]> {
  const vehiclesCollectionRef = collection(firestore, COLLECTIONS.VEHICLES);

  const q = query(
    vehiclesCollectionRef,
    where("originId", "==", dealerId ? dealerId : ""),
  );

  const querySnapshot = await getDocs(q);

  const items = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  })) as VehiclesInfoDTO[];

  return items;
}

export async function getVehicle(id: string): Promise<VehiclesInfoDTO> {
  const docRef = doc(firestore, COLLECTIONS.VEHICLES, id);
  const docSnap = await getDoc(docRef);

  return docSnap.data() as VehiclesInfoDTO;
}

export async function getVehicleObservation(
  id: string
): Promise<ObservationsDTO> {
  const docRef = doc(firestore, COLLECTIONS.OBSERVATIONS, id);
  const docSnap = await getDoc(docRef);

  return docSnap.data() as ObservationsDTO;
}
